import { SUPPORT_REQUEST_STATUS } from '@/shared/config';
import { SUPPORT_REQUEST_TYPE } from '@/entities/support';
import { invertObject } from '@/shared/lib';

const SUPPORT_REQUEST_TYPE_INVERSE = invertObject(SUPPORT_REQUEST_TYPE);

const SUPPORT_REQUEST_STATUS_INVERSE = invertObject(SUPPORT_REQUEST_STATUS);

export { SUPPORT_REQUEST_STATUS_INVERSE, SUPPORT_REQUEST_TYPE_INVERSE };
